import { isSameMonth } from 'date-fns'

import { EMPTY_OBJECT } from '../../../constants/common'
import { NUMBER_SIZE } from '../../../constants/size'
import { useDateLocale } from '../../../hooks'
import { MonthDay } from '../MonthDay'

import { getMonthDays } from './MonthDays.utils'

import * as styles from './MonthDays.module.css'

function MonthDays({
  Element = 'div',
  Item = MonthDay,
  className = styles.MonthDays,
  getDays = getMonthDays,
  itemProps: {
    className: itemClassName = styles.item,
    ...itemProps
  } = EMPTY_OBJECT,
  size = NUMBER_SIZE.size40,
  today = null,
  value,
  ...elementProps
}) {
  const locale = useDateLocale()

  const dates = getDays(value, locale)

  return (
    <Element {...elementProps} className={className}>
      {dates.map(date => (
        <Item
          {...itemProps}
          className={itemClassName}
          current={isSameMonth(value, date)}
          key={Number(date)}
          size={size}
          today={today}
          value={date}
        />
      ))}
    </Element>
  )
}

export default MonthDays
